// extracted by mini-css-extract-plugin
export var bodyRow = "_d9-d";
export var cardColumns = "_d9-e";
export var ellipsesOverflow = "_d9-2";
export var flatBottomCorners = "_d9-3";
export var flatTopCorners = "_d9-4";
export var headerActionsDropdown = "_d9-f";
export var headerBottomRow = "_d9-c";
export var headerTopRow = "_d9-b";
export var orderDetailsWrapper = "_d9-0";
export var orderInfoContainer = "_d9-1";
export var productDetails = "_d9-9";
export var productImage = "_d9-5";
export var responsiveTable = "_d9-8";
export var shipmentContainer = "_d9-a";
export var tableBottomLeft = "_d9-6";
export var tableBottomRight = "_d9-7";
export var trackingLink = "_d9-g";